import React from 'react';
import { Link } from 'react-router-dom';
import { bannerService } from '../../services/bannerService';
import { getMediaUrl } from '../../services/api';

export default class Breadcrumb extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dbBanner: null
        };
    }

    async componentDidMount() {
        const pageKey = this.props.page || (this.props.heading ? this.props.heading.toLowerCase().replace(/\s+/g, '') : null);
        if (pageKey) {
            try {
                // Map common headings to banner pages
                let targetPage = pageKey;
                if (pageKey.includes('about')) targetPage = 'about';
                else if (pageKey.includes('service')) targetPage = 'services';
                else if (pageKey.includes('project')) targetPage = 'projects';
                else if (pageKey.includes('contact')) targetPage = 'contact';
                else if (pageKey.includes('rdso')) targetPage = 'rdso';

                const res = await bannerService.getPublicBanners(targetPage);
                if (res.success && res.data && res.data.length > 0) {
                    this.setState({ dbBanner: res.data[0] });
                }
            } catch (err) {
                // Keep default props fallback
            }
        }
    }

    render() {
        const { dbBanner } = this.state;
        const publicUrl = process.env.PUBLIC_URL + '/';
        const heading = dbBanner && dbBanner.title ? dbBanner.title : this.props.heading;
        const currentPage = this.props.currentPage ? this.props.currentPage : heading;

        let bgStyle;
        if (dbBanner && dbBanner.image) {
            bgStyle = { backgroundImage: `url(${getMediaUrl(dbBanner.image)})` };
        } else {
            const Img = this.props.Img ? this.props.Img : 'page-header-img.jpg';
            bgStyle = { backgroundImage: `url(${publicUrl}assets/images/backgrounds/${Img})` };
        }

        return (
            <>
                <section className="page-header">
                    <div className="page-header__bg" style={bgStyle}></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="page-header__wrapper">
                                    <div className="page-header__content">
                                        <h2>{heading}</h2>
                                        <div className="page-header__menu">
                                            <ul>
                                                <li><Link to={process.env.PUBLIC_URL + `/`}>Home</Link></li>
                                                <li>{currentPage}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}